import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PayeeInputDirective } from '../../payee-input/payee-input.directive';
import { PayeeCopyButtonComponent } from '../../payee-buttons/payee-copy-button/payee-copy-button.component';

@Component({
  selector: 'payee-copy-form-field',
  templateUrl: './payee-copy-form-field.component.html',
  styleUrls: ['./payee-copy-form-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PayeeCopyFormFieldComponent),
      multi: true,
    },
  ],
  imports: [PayeeInputDirective, PayeeCopyButtonComponent],
})
export class PayeeCopyFormFieldComponent implements ControlValueAccessor {
  @Input() placeholder = '';

  value: any;

  // ControlValueAccessor

  onChange = (_obj: any) => {};

  onTouched = () => {};

  registerOnChange(fn: (obj: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  change(value: any) {
    this.onChange(value);
  }
}
